import styled from "styled-components";
import { MOBILE } from "../../constants/breakpoints";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    background-repeat: no-repeat;
    background-position: top right;
    margin-bottom: 44px;
    .section{
        display: flex;
        width: 1140px;
        margin: 0 auto;
        margin-top: 110px;
        gap: 70px;
        justify-content: center;
        @media (max-width: ${MOBILE}px) {
            width: 100%;
            padding: 0 12px;
        }
        .main{
            display: flex;
            column-gap: 50px;
            @media (max-width: ${MOBILE}px) {
                flex-direction: column;
            }
        }
        .titleSpan {
            @media (max-width: ${MOBILE}px) {
                width: 60%;
            }
        }
        .nameText {
            font-size: 24px;
            font-weight: 700;
            @media (max-width: ${MOBILE}px) {
                font-size: 24px;
            }
        }
        .descriptionText{
            font-weight: 500;
            font-size: 16px;
            margin: 0;
            margin-top: 5px;
            @media (max-width: ${MOBILE}px) {
                font-size: 14px;
            }
        }
        .viewMoreText {
            color: #757272;
            cursor: pointer;
        }
        .noDescriptionText {
            color: #757272;
            cursor: pointer;
                padding-top: 5px;
            }

    }

`

export const DataContainer = styled.div`
    display: flex;
    margin-top: 40px;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 32px;
    flex-direction: column;

    @media (max-width: ${MOBILE}px) {
        width: 100%;
        padding: 24px 16px;
        height: max-content;
    }

    .topSection {
        display: 100%;
        display: flex;
    }
    .bottomSection{
        display: flex;
        flex-direction: column;
        margin-top: 36px;
        gap: 24px;
    }
    .icon-image {
        width: 128px;
        height: 128px;
        @media (max-width: ${MOBILE}px) {
            width: 64px;
            height: 64px;
        }
    }
    .textSpan {
        display: flex;
        flex-direction: column;
        width: 75%;
        margin-top: 70px;

        @media (max-width: ${MOBILE}px) {
            margin-top: 0;
        }
        .h1Text {
            font-weight: 700;
            font-size: 24px;
            margin: 0;

            @media (max-width: ${MOBILE}px) {
                font-size: 16px;
            }
        }
    }
`

export const InfoContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .labelText{
        font-weight: 500;
        font-size: 16px;
        color: #757272;
        margin: 0;
        margin-right: auto;
        width: max-content;

        @media (max-width: ${MOBILE}px) {
            font-size: 14px;
        }
    }
    .titleText {
        font-weight: 500;
        font-size: 16px;
        color: #191414;
        margin: 0;
        margin-left: auto;

        @media (max-width: ${MOBILE}px) {
            font-size: 14px;
        }
    }
    .checkIcon {
        margin-left: 5px;
        circle{
            fill: #96da96;
        }
        path{
            fill: #036403;
        }
    }
    .copyIcon {
        margin-left: 5px;
        cursor: pointer;
        &:hover {
            margin-left: 10px;
            transform: scale(1.2);
            transition: all 0.2s ease-in-out;
        }
    }
`

export const Dots = styled.span`
    display: flex;
    flex-grow: 1;
    border: 1px dashed #a29b8b84;
    margin: 0 8px;
    margin-top: auto;
    margin-bottom: 5px;
`

export const SuccessContainer = styled.section`
    display: flex;
    margin-top: 40px;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    @media (max-width: ${MOBILE}px) {
        width: 100%;
        height: max-content;
        padding: 16px 24px;
    }
`